import classNames from "classnames";
import { useFormikContext } from "formik";
import React from "react";
import { Accordion } from "react-bootstrap";

import { IFormITR1 } from "../../../config/interfaces";
import PriceDisplay from "../../PriceDisplay";
import { ContextAwareToggle } from "../../accordion";

type Props = {};

const AccSalaryIncome: React.FC<Props> = (props: Props) => {
  const { values } = useFormikContext<IFormITR1>();

  return (
    <>
      {values.IncomeDetails?.Salaries?.length > 0 ? (
        <>
          <Accordion.Item eventKey="income-source-1">
            <ContextAwareToggle eventKey="income-source-1" isChild={true}>
              <div className="btn-content justify-content-between">
                <p className="leading-para fw-bold mb-0">Salary Income</p>
                <p className="leading-para fw-bold mb-0">
                  <PriceDisplay price={values.IncomeFromSal} />
                </p>
              </div>
            </ContextAwareToggle>
            <Accordion.Body>
              <section>
                <dl className="eds-list eds-dl eds-inline-between">
                  {values.IncomeDetails?.Salaries?.map((salary, index) => (
                    <React.Fragment key={`salary-source-${index}`}>
                      <p className="leading-para fw-bold text-primary">
                        {index + 1}. {salary.EmployerName}
                      </p>
                      <RenderListItem title="Gross Salary" amount={salary.GrossSalary} />

                      <RenderListItem
                        title="Less: Allowances exempt u/s 10"
                        amount={salary.ExemptAllowancesUnderSection10}
                      />

                      <RenderListItem title="Net Salary" amount={salary.NetSalary} />
                    </React.Fragment>
                  ))}

                  <RenderListItem
                    title="Total Salary"
                    amount={values.NetSalary}
                    isSubtotal={true}
                  />

                  <RenderListItem
                    title="Less: Standard Deduction - 16(ia)"
                    amount={values.DeductionUs16ia}
                  />

                  <RenderListItem
                    title="Less: Entertainment Allowance - 16(ii)"
                    amount={values.EntertainmentAlw16ii}
                  />

                  <RenderListItem
                    title="Less: Professional Tax - 16(iii)"
                    amount={values.ProfessionalTaxUs16iii}
                  />

                  <RenderListItem
                    title="Less: Relief under section 89"
                    amount={values.TotalReliefUs89}
                  />

                  <RenderListItem
                    title="Less: Income claimed for relief u/s 89A"
                    amount={values.TotalIncClaimedForReliefUs89A}
                  />

                  <RenderListItem
                    title="Total Taxable Salary"
                    amount={values.IncomeFromSal}
                    isSubtotal={true}
                  />
                </dl>
              </section>
            </Accordion.Body>
          </Accordion.Item>
        </>
      ) : null}
    </>
  );
};

export default AccSalaryIncome;

const RenderListItem = ({
  amount,
  title,
  isSubtotal = false
}: {
  amount: number | string;
  title: string;
  isSubtotal?: boolean;
}) => {
  return (
    <>
      {amount ? (
        <div className={classNames("eds-list--item", isSubtotal && "eds-list--item-subtotal")}>
          <dt>{title}</dt>
          <dd>
            <PriceDisplay price={amount} />
          </dd>
        </div>
      ) : null}
    </>
  );
};
